"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Level = void 0;
var Level;
(function (Level) {
    Level["Foundation"] = "foundation";
    Level["Higher"] = "higher";
    Level["A Level"] = "a-level";
    Level["AS"] = "as";
})(Level = exports.Level || (exports.Level = {}));
//# sourceMappingURL=index.js.map